
import ClaimUnclaimCME from '../common/ClaimUnclaimCME'
 

export default function MostRecentActivitiesDashboard(props:any){
  return(
    <ClaimUnclaimCME source='Transcript'/>
  )

}